interface ProgressBarProps {
    progress: number;
}
const ProgressBar = ({ progress }: ProgressBarProps) => (
    <div className="space-y-4">
        <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Progreso General</span>
            <span className="font-medium text-gray-900 dark:text-white">{progress}%</span>
        </div>
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-3">
            <div
                className="bg-blue-600 dark:bg-blue-500 h-3 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
            />
        </div>
    </div>
);

export default ProgressBar;